module.exports = "<p>detalles works!</p>\n"